import socket from "@/services/socket";
import {
  useGrimoireStore,
  useLocaleStore,
  usePlayersStore,
  useRochamboStore,
  useSessionStore,
  useVotingStore,
} from "@/stores"
import type {
  Player,
  Role,
} from "@/types"
export function sendGameState(playerId = "", isLightweight = false) {
  const session = useSessionStore();
  if (session.isPlayerOrSpectator) return;
  const grimoireStore = useGrimoireStore();
  const playersStore = usePlayersStore();
  const votingStore = useVotingStore();
  const localeStore = useLocaleStore();
  const rochamboStore = useRochamboStore();

  socket.gamestate = playersStore.players.map((player: Player) => ({
    name: player.name,
    id: player.id,
    isDead: player.isDead,
    voteToken: player.voteToken,
    pronouns: player.pronouns,
    discordTag: player.discordTag,
    secretRole: player.secretRole,
    handRaisedAt: player.handRaisedAt ?? null,
    ...(player.role?.team === "traveler" ? { roleId: player.role?.id } : {}),
  }));
  if (isLightweight) {
    socket.sendDirect(playerId, "gs", {
      gamestate: socket.gamestate,
      isLightweight,
    });
  } else {
    socket.sendEdition(playerId);
    const voteHistory = [...votingStore.voteHistory];

    if (grimoireStore.isVoteHistoryAllowed) {
      // Sanitize anonymous votes
      voteHistory.forEach((entry, i) => {
        if (entry.anonymous) {
          voteHistory[i] = { ...entry, voters: [] };
        }
      });
    } else {
      // Clear history if not allowed
      voteHistory.length = 0;
    }

    socket.sendDirect(playerId, "gs", {
      gamestate: socket.gamestate,
      gamePhase: grimoireStore.gamePhase,
      dayCount: grimoireStore.dayCount,
      timer: grimoireStore.timer,
      allowSelfNaming: grimoireStore.allowSelfNaming,
      isVoteHistoryAllowed: grimoireStore.isVoteHistoryAllowed,
      isSecretVoteMode: grimoireStore.isSecretVote,
      isTextChatAllowed: grimoireStore.isTextChatAllowed,
      nomination: votingStore.nomination,
      votingSpeed: votingStore.votingSpeed,
      lockedVote: votingStore.lockedVote,
      isVoteInProgress: votingStore.isVoteInProgress,
      markedPlayer: votingStore.markedPlayer,
      fabled: playersStore.fabled.map((f: Role) =>
        f.isCustom ? f : { id: f.id }
      ),
      ...(votingStore.nomination ? { votes: votingStore.votes } : {}),
      voteHistory,
      rochambo: rochamboStore.sharedMatch,
      locale: localeStore.currentLanguage,
    });
  }
}
